/*
  Project: Wealthfront
  Author: Marcin Ziolek
 */

import 'picturefill';
import osDetect from './modules/os-detect';
import scrollProgress from './modules/scroll-progress';
import postHeader from './modules/post-header';
import header from './modules/header';
import nav from './modules/nav';
import appLink from './modules/app-link';
import carousel from './modules/carousel';
import learn from './modules/learn';
import search from './modules/search';
import loadMore from './modules/load-more-articles';
import related from './modules/related';
import footerNav from './modules/footer-nav';
import 'slick-carousel';

osDetect();
scrollProgress();
postHeader();
header();
nav();
appLink();
carousel();
learn();
search();
loadMore();
related();
footerNav();



// WEBPACK FOOTER //
// ./src/scripts/app.js